import React from 'react'
import type { TCustomEndpointAccessCheckDto } from '@homepal/api-contract'

import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'
import Stack from 'components_new/atoms/Stack'
import TooltipWrapper from 'components_new/atoms/TooltipWrapper'


export type TRowAccessCheck = {
  checking: boolean
  result: TCustomEndpointAccessCheckDto | null
}

interface EndpointAccessCellProps {
  check: TRowAccessCheck | undefined
  onCheck: () => void
}

/**
 * The "does the source let us read this?" cell of an endpoint row: a button
 * to ask, and the answer as an icon whose tooltip carries the reason.
 */
const EndpointAccessCell = (props: EndpointAccessCellProps) => {
  const { check, onCheck } = props

  const result = check?.result ?? null

  return (
    <Stack alignItems="center" direction="row" justifyContent="flex-end">
      {result ? (
        <TooltipWrapper
          title={result.accessible ? 'Går att läsa' : result.error}
        >
          <Icon
            color={result.accessible ? 'success' : 'error'}
            fontSize="small"
            name={result.accessible ? 'CheckCircleOutline' : 'ErrorOutline'}
          />
        </TooltipWrapper>
      ) : null}

      <TooltipWrapper title="Kontrollera åtkomst">
        <IconButton disabled={check?.checking} onClick={onCheck} size="small">
          <Icon fontSize="small" name="RuleOutlined" />
        </IconButton>
      </TooltipWrapper>
    </Stack>
  )
}

export default EndpointAccessCell
